import { render, staticRenderFns } from "./goodListScrollNew.vue?vue&type=template&id=d8740412&scoped=true"
import script from "./goodListScrollNew.vue?vue&type=script&lang=js"
export * from "./goodListScrollNew.vue?vue&type=script&lang=js"
import style0 from "./goodListScrollNew.vue?vue&type=style&index=0&id=d8740412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8740412",
  null
  
)

export default component.exports